/**
 * Dashboard SVG Icon Registry (Tailwind-style: 중앙 정의 → 필요한 곳에서 이름으로 사용)
 * Usage: getDashboardIcon('credit-card') or getDashboardIcon('info', { width: 18, height: 18 })
 */
(function () {
  "use strict";

  var ICONS = {
    /** 정보(i) - 상태/취소 사유 툴팁 등. stroke=currentColor 권장 */
    info:
      '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"></circle><line x1="12" y1="16" x2="12" y2="12"></line><line x1="12" y1="8" x2="12.01" y2="8"></line></svg>',

    /** 결제 만료(시계) - fill 고정 */
    "payment-expired":
      '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm.5-13H11v6l5.25 3.15.75-1.23-4.5-2.67z" fill="#dc3545"/></svg>',

    /** 보안(방패) - stroke=white 등으로 사용 */
    shield:
      '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"></path></svg>',

    /** 청구서/카드 - stroke=white 또는 currentColor */
    "credit-card":
      '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"><rect x="2" y="5" width="20" height="14" rx="2"></rect><line x1="2" y1="10" x2="22" y2="10"></line></svg>',

    /** 결제 필요(채움 카드) - fill #709bd4, Payment Required 배너용 */
    "payment-required":
      '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M20 4H4c-1.11 0-1.99.89-1.99 2L2 18c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V6c0-1.11-.89-2-2-2zm0 14H4v-6h16v6zm0-10H4V6h16v2z" fill="#709bd4"/></svg>',

    /** 빈 상태(빈 박스) - empty state, stroke=currentColor */
    empty:
      '<svg width="80" height="80" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"/><polyline points="3.27 6.96 12 12.01 20.73 6.96"/><line x1="12" y1="22.08" x2="12" y2="12"/></svg>',

    /** 위를 가리키는 손가락 - Select Packages 등 안내용, fill=currentColor */
    "point-up":
      '<svg width="48" height="48" viewBox="0 0 30 30" fill="currentColor" xmlns="http://www.w3.org/2000/svg"><path d="M 11 2 C 9.895 2 9 2.895 9 4 L 9 12 L 9 13 L 9 19.5 C 6.448 18.201 5.289 18 4 18 C 2.503911 18 1.0097445 18.577311 1.0019531 20.486328 L 5.5 22.5 L 8.65625 25.65625 C 10.15625 27.15625 12.192453 28 14.314453 28 L 21 28 C 23.209 28 25 26.209 25 24 L 25 14 A 2 2 0 0 0 23 12 A 2 2 0 0 0 21.193359 13.148438 C 21.066812 13.062233 21 13 21 13 A 2 2 0 0 0 19 11 A 2 2 0 0 0 17 13 L 17 12 C 17 10.895 16.105 10 15 10 C 13.895 10 13 10.895 13 12 L 13 4 C 13 2.895 12.105 2 11 2 z M 1.0019531 20.486328 L 1 20.486328 L 1 20.5 C 1 20.494991 1.0019328 20.491319 1.0019531 20.486328 z"/></svg>',

    /** 긴급/주의 - Need to Pay 배너 등, stroke=currentColor (배너에서 color:white 상속) */
    urgent:
      '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"/><line x1="12" y1="9" x2="12" y2="13"/><line x1="12" y1="17" x2="12.01" y2="17"/></svg>',

    /** 사이렌(긴급 결제 필요) - Need to Pay 배너 등, icons8 fluence */
    siren:
      '<img width="24" height="24" src="https://img.icons8.com/fluency/48/siren.png" alt="" style="display: block; flex-shrink: 0;" />',

    /** 알람(긴급 결제 필요) - Need to Pay 배너 등, icons8 fluence */
    alarm:
      '<img width="24" height="24" src="https://img.icons8.com/liquid-glass/48/alarm.png" alt="" style="display: block; flex-shrink: 0;" />',
  };

  /**
   * @param {string} name - 아이콘 이름 (info | payment-expired | shield | credit-card | point-up | urgent | siren)
   * @param {{ width?: number, height?: number, stroke?: string }} [opts] - width/height/stroke 오버라이드
   * @returns {string} SVG HTML 문자열
   */
  function getDashboardIcon(name, opts) {
    var svg = ICONS[name];
    if (!svg) return "";
    if (!opts) return svg;
    var out = svg;
    if (opts.width != null || opts.height != null) {
      var w = opts.width != null ? opts.width : 24;
      var h = opts.height != null ? opts.height : 24;
      out = out
        .replace(/\bwidth="[^"]*"/, 'width="' + w + '"')
        .replace(/\bheight="[^"]*"/, 'height="' + h + '"');
    }
    if (opts.stroke != null) {
      out = out.replace(/\bstroke="[^"]*"/, 'stroke="' + opts.stroke + '"');
    }
    return out;
  }

  window.DashboardIcons = ICONS;
  window.getDashboardIcon = getDashboardIcon;

  /** Liquid 등에서 data-dashboard-icon 사용 시 DOM 로드 후 아이콘 주입 */
  function injectDataIcons() {
    var nodes = document.querySelectorAll("[data-dashboard-icon]");
    nodes.forEach(function (el) {
      var name = el.getAttribute("data-dashboard-icon");
      if (!name) return;
      var w = el.getAttribute("data-icon-width");
      var h = el.getAttribute("data-icon-height");
      var opts = (w != null || h != null) ? { width: w ? parseInt(w, 10) : 24, height: h ? parseInt(h, 10) : 24 } : undefined;
      el.innerHTML = getDashboardIcon(name, opts) || "";
    });
  }
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", injectDataIcons);
  } else {
    injectDataIcons();
  }
})();
